import { render, staticRenderFns } from "./WindowManagerDragger.vue?vue&type=template&id=774ad8ae&scoped=true&"
import script from "./WindowManagerDragger.vue?vue&type=script&lang=js&"
export * from "./WindowManagerDragger.vue?vue&type=script&lang=js&"
import style0 from "./WindowManagerDragger.vue?vue&type=style&index=0&id=774ad8ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774ad8ae",
  null
  
)

export default component.exports